import { API_BASE_URL } from "./adminHelpers";

let socketScriptPromise = null;

export function loadAdminSocketIoClient() {
  if (window.io) {
    return Promise.resolve(window.io);
  }

  if (socketScriptPromise) {
    return socketScriptPromise;
  }

  socketScriptPromise = new Promise((resolve, reject) => {
    const existingScript = document.querySelector("script[data-instateam-socket-client='true']");
    if (existingScript) {
      existingScript.addEventListener("load", () => {
        if (window.io) resolve(window.io);
      });
      existingScript.addEventListener("error", () => {
        reject(new Error("Unable to load Socket.IO client."));
      });
      return;
    }

    const script = document.createElement("script");
    script.src = `${API_BASE_URL}/socket.io/socket.io.js`;
    script.async = true;
    script.dataset.instateamSocketClient = "true";
    script.onload = () => {
      if (window.io) {
        resolve(window.io);
        return;
      }
      reject(new Error("Socket.IO client is not available after loading."));
    };
    script.onerror = () => reject(new Error("Unable to load Socket.IO client."));
    document.body.appendChild(script);
  });

  return socketScriptPromise;
}

export async function connectAdminChatSocket(token) {
  const io = await loadAdminSocketIoClient();

  return io(API_BASE_URL, {
    transports: ["websocket", "polling"],
    query: {
      token,
      instateamRole: "admin",
    },
  });
}
